import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import {
  CourseValidationSubType,
  CourseValidationType,
} from '../../../types/CourseValidationType';

export interface FormData {
  courseName?: string;
  validationType?: FieldSelects['validationType'];
  rapOption?: FieldSelects['rapOption'];
  examGrade?: string | null;
  courseGrade?: string | null;
  description?: string;
  code?: string;
  doc?: {
    name: string;
    url: string;
  };
}

export interface FieldSelects {
  validationType: { label: string; value: CourseValidationType };
  rapOption: { label: string; value: CourseValidationSubType };
}

const useTextValidationType = () => {
  const { t } = useTranslation();
  const prefix = 'courseValidationInternalStudent.modalValidationType';

  const texts = useMemo(
    () => ({
      title: t(`${prefix}.title`),
      subTitle: t(`${prefix}.subTitle`),
      courseNameLabel: t(`${prefix}.courseNameLabel`),
      courseCodeLabel: t(`${prefix}.courseCodeLabel`),
      examGradeLable: t(`${prefix}.examGradeLabel`),
      externalGradeLabel: t(`${prefix}.externalGradeLabel`),
      institutionLabel: t(`terms:institution.single`),
      courseGradeLabel: t(`${prefix}.courseGradeLabel`),
      externalCourseGradeTooltip: t(`${prefix}.externalCourseGradeTooltip`),
      externalExternalGradeTooltip: t(`${prefix}.externalExternalGradeTooltip`),
      externalCourseName: t(`terms:course.single`),
      invalidGrade: t(`${prefix}.invalidGrade`),
      description: {
        label: t('common.forms.description'),
        placeholder: t(`common.forms.descriptionPlaceholder`),
      },
      validationType: {
        selectLabel: t(`${prefix}.validationType.selectLabel`),
        internal: t(`${prefix}.validationType.internal`),
        external: t(`${prefix}.validationType.external`),
        rap: t(`${prefix}.validationType.rap`),
      },
      rapType: {
        selectLabel: t(`${prefix}.rapType.selectLabel`),
        validation: t(`${prefix}.rapType.validation`),
        proficiency: t(`${prefix}.rapType.proficiency`),
      },
      uploadFile: {
        label: t(`${prefix}.uploadFile.label`),
        button: t(`${prefix}.uploadFile.button`),
      },
      dowmnloadFile: {
        label: t(`${prefix}.dowmnloadFile.label`),
        button: t(`${prefix}.dowmnloadFile.button`),
      },
      actions: {
        cancel: t(`${prefix}.actions.cancel`),
        confirm: t(`${prefix}.actions.confirm`),
        close: t(`${prefix}.actions.close`),
      },
      required: t('common.validations.required'),
      toast: {
        success: t(`${prefix}.toast.success`),
        error: t(`${prefix}.toast.error`),
      },
    }),
    [t],
  );

  const validationOptions: FieldSelects['validationType'][] = [
    {
      label: texts.validationType.internal,
      value: CourseValidationType.Internal,
    },
    { label: texts.validationType.rap, value: CourseValidationType.RAP },
    {
      label: texts.validationType.external,
      value: CourseValidationType.External,
    },
  ];

  const rapOptions: FieldSelects['rapOption'][] = [
    {
      label: texts.rapType.validation,
      value: CourseValidationSubType.Validation,
    },
    {
      label: texts.rapType.proficiency,
      value: CourseValidationSubType.Proficiency,
    },
  ];

  return {
    texts,
    validationOptions,
    rapOptions,
  };
};

export default useTextValidationType;
